// src/pages/UploadExcelPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UploadExcel.css';

import certificateImg from '../../assests/Preview.png';
import walletImg from '../../assests/age-verify.png';

const uploadTemplates = [
  {
    id: 1,
    name: 'Digital Certificate Issuance',
    image: certificateImg,
    file: '/template/CMS-Certificate.xlsx',
    description: 'Bulk issue digital certificates such as CMS, Training, or Internship credentials.',
  },
  {
    id: 2,
    name: 'EarthID Wallet Issuance',
    image: walletImg,
    file: '/template/Wallet-Issuance.xlsx',
    description: 'Bulk generate EarthID wallets for your users and send them via email.',
  },
];

export default function UploadExcelPage() {
  const navigate = useNavigate();

  return (
    <div className="profile-layout">
      <button className="gradient-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h1 className="profile-title">Bulk Upload Wallets & Certificates</h1>

      {/* ————————— Instructions ————————— */}
      <section className="profile-section">
        <div className="info-card">
          <h2 className="section-description">📄 How It Works</h2>

          <p>
            Use this page to issue hundreds of <strong>EarthID Wallets</strong> or <strong>Digital Certificates</strong> at once using a spreadsheet template.
          </p>

          <ol>
            <li>
              <strong>Select a product:</strong> Choose a template below based on what you want to issue (Wallet or Certificate). Download the sample Excel file with the correct column headers.
            </li>
            <li>
              <strong>Edit the Excel file:</strong> Use Excel or Google Sheets to fill in user data. Do not change the headers.
            </li>
            <li>
              <strong>Prepare data rows:</strong> Each row represents one recipient. Required fields include <code>firstName</code>, <code>lastName</code>, <code>email</code>, etc.
            </li>
            <li>
              <strong>Save your file:</strong> Keep the format as <code>.xlsx</code> and make sure it's under <strong>5MB</strong>.
            </li>
            <li>
              <strong>Upload via API:</strong> Send the file to the relevant bulk-upload API:
              <ul>
                <li><code>/api/certificates/bulk-upload</code> for certificates</li>
                <li><code>/api/wallets/bulk-upload</code> for wallets</li>
              </ul>
            </li>
            <li>
              <strong>Verify output:</strong> Issued items will be emailed automatically. You can check status on the Dashboard or Reports page.
            </li>
          </ol>
        </div>
      </section>
      {/* ——————————————————————————————— */}

      <div className="templates-grid">
        {uploadTemplates.map(t => (
          <div key={t.id} className="template-card">
            <div className="template-image-container">
              <img src={t.image} alt={t.name} className="template-image" />
            </div>
            <h3 className="template-name">{t.name}</h3>
            <p className="template-description">{t.description}</p>
            <button
              className="gradient-btn"
              onClick={() => {
                const link = document.createElement('a');
                link.href = t.file;
                link.download = t.file.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              Download Sample Input File
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
